export const edwinGroupName = [
    'edwin_stock_group_1',
    'edwin_stock_group_2',
    'edwin_stock_group_3',
    'edwin_stock_group_4',
];
